import HTTP from "@/_helpers/http";
import { AGREEMENTS__API } from "@/_helpers/urls";
import { AGREEMENTS__MUTATIONS } from "../mutation-types";
import { AGREEMENTS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    tradingAgreements: [],
    othersAgreements: [],
    ibAgreements: [],
    acceptedAgreements: [],
    notAcceptedAgreements: [],
    clientsAgreementsHistories: [],
    partnersAgreementsHistories: [],
    pagination: {
        total: 0,
        perPage: 10,
        currentPage: 1,
        lastPage: 1
    },
    ibPagination: {
        total: 0,
        perPage: 10,
        currentPage: 1,
        lastPage: 1
    },
    tradingPagination: {
        total: 0,
        perPage: 10,
        currentPage: 1,
        lastPage: 1
    },

};

//Getters
const getters = {};

//Mutations
const mutations = {
    [AGREEMENTS__MUTATIONS.GETOTHERSAGREEMENTS](state, data) {
        state.othersAgreements = data?.data?.agreements;
        state.pagination = data?.data?.pagination;
    },
    [AGREEMENTS__MUTATIONS.GETIBAGREEMENTS](state, data) {
        state.ibAgreements = data?.data?.agreements;
        state.ibPagination = data?.data?.pagination;
    },
    [AGREEMENTS__MUTATIONS.GETTRADINGAGREEMENTS](state, data) {
        state.tradingAgreements = data?.data?.agreements;
        state.tradingPagination = data?.data?.pagination;
    },
    [AGREEMENTS__MUTATIONS.ACCEPTEDAGREEMENTS](state, data) {
        state.acceptedAgreements = data?.agreements;
    },
    [AGREEMENTS__MUTATIONS.NOTACCEPTEDAGREEMENTS](state, data) {
        state.notAcceptedAgreements = data?.agreements;
    },
    [AGREEMENTS__MUTATIONS.GETCLIENTSAGREEMENTSHISTORIES](state, data) {
        state.clientsAgreementsHistories = data?.data?.agreements;
    },
    [AGREEMENTS__MUTATIONS.GETPARTNERSAGREEMENTSHISTORIES](state, data) {
        state.partnersAgreementsHistories = data?.data?.agreements;
    },
    SET_LOADING(state, data) {
        state.isLoading = data;
    },
};

// Actions
const actions = {
    async [AGREEMENTS__ACTIONS.UPDATECLIENTSAGREEMENTSTATUS]({ commit, state, dispatch }, data) {
        try {
            const url = `${AGREEMENTS__API.UPDATECLIENTSAGREEMENTSTATUS}`;
            const response = await HTTP().patch(url, data);

            if (response.status === 200) {
                await dispatch(AGREEMENTS__ACTIONS.GETCLIENTSAGREEMENTSHISTORIES);
                await dispatch(AGREEMENTS__ACTIONS.GETTRADINGAGREEMENTS);
                await dispatch(AGREEMENTS__ACTIONS.GETOTHERSAGREEMENTS);
                toast.success(response.data.message || "Agreement updated successfully");
            }
        } catch (error) {
            console.log(error);
            toast.error("Failed to update agreement");
        }
    },

    async [AGREEMENTS__ACTIONS.CREATEAGREEMENT]({ commit, state, dispatch }, data) {
        try {
            const url = `${AGREEMENTS__API.CREATEAGREEMENT}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                await dispatch(AGREEMENTS__ACTIONS.GETTRADINGAGREEMENTS);
                await dispatch(AGREEMENTS__ACTIONS.GETOTHERSAGREEMENTS);
                await dispatch(AGREEMENTS__ACTIONS.GETIBAGREEMENTS);
                toast.success(response.data.message || "Agreement created successfully");
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to create agreement");
        }
    },

    async [AGREEMENTS__ACTIONS.ACCEPTEDAGREEMENTS]({ commit, state }, id) {
        try {
            const url = `${AGREEMENTS__API.ACCEPTEDAGREEMENTS}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(AGREEMENTS__MUTATIONS.ACCEPTEDAGREEMENTS, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [AGREEMENTS__ACTIONS.GETCLIENTSAGREEMENTSHISTORIES]({ commit, state }, parameter = {}) {
        try {
            const {
                page = 1,
                limit = 10,
                search = "",
                status
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(search && { search }),
                ...(status && { status })
            }).toString();

            const response = await HTTP().get(
                `${AGREEMENTS__API.GETCLIENTSAGREEMENTSHISTORIES}${queryParams ? `?${queryParams}` : ''}`
            );

            if (response.status === 200) {
                commit(AGREEMENTS__MUTATIONS.GETCLIENTSAGREEMENTSHISTORIES, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [AGREEMENTS__ACTIONS.GETPARTNERSAGREEMENTSHISTORIES]({ commit, state }, parameter = {}) {
        try {
            const {
                page = 1,
                limit = 10,
                search = "",
                status
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(search && { search }),
                ...(status && { status })
            }).toString();

            const response = await HTTP().get(
                `${AGREEMENTS__API.GETPARTNERSAGREEMENTSHISTORIES}${queryParams ? `?${queryParams}` : ''}`
            );

            if (response.status === 200) {
                commit(AGREEMENTS__MUTATIONS.GETPARTNERSAGREEMENTSHISTORIES, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [AGREEMENTS__ACTIONS.NOTACCEPTEDAGREEMENTS]({ commit, state }, id) {
        try {
            const url = `${AGREEMENTS__API.NOTACCEPTEDAGREEMENTS}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(AGREEMENTS__MUTATIONS.NOTACCEPTEDAGREEMENTS, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [AGREEMENTS__ACTIONS.GETOTHERSAGREEMENTS]({ commit, state }, parameter = {}) {
        try {
            const {
                page = 1,
                limit = 10,
                search = ""
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(search && { search })
            }).toString();

            const response = await HTTP().get(
                `${AGREEMENTS__API.GETOTHERSAGREEMENTS}${queryParams ? `?${queryParams}` : ''}`
            );

            if (response.status === 200) {
                commit(AGREEMENTS__MUTATIONS.GETOTHERSAGREEMENTS, response.data);

            } else {
                commit(AGREEMENTS__MUTATIONS.GETOTHERSAGREEMENTS, []);

            }
        } catch (error) {
            console.log(error);
        }
    },

    async [AGREEMENTS__ACTIONS.GETIBAGREEMENTS]({ commit, state }, parameter = {}) {
        try {
            const {
                page = 1,
                limit = 10,
                search = ""
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(search && { search })
            }).toString();

            const response = await HTTP().get(
                `${AGREEMENTS__API.GETIBAGREEMENTS}${queryParams ? `?${queryParams}` : ''}`
            );

            if (response.status === 200) {
                commit(AGREEMENTS__MUTATIONS.GETIBAGREEMENTS, response.data);

            } else {
                commit(AGREEMENTS__MUTATIONS.GETIBAGREEMENTS, []);

            }
        } catch (error) {
            console.log(error);
        }
    },

    async [AGREEMENTS__ACTIONS.GETTRADINGAGREEMENTS]({ commit, state }, parameter = {}) {
        try {
            const {
                page = 1,
                limit = 10,
                search = ""
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(search && { search })
            }).toString();

            const response = await HTTP().get(
                `${AGREEMENTS__API.GETTRADINGAGREEMENTS}${queryParams ? `?${queryParams}` : ''}`
            );

            if (response.status === 200) {
                commit(AGREEMENTS__MUTATIONS.GETTRADINGAGREEMENTS, response.data);

            } else {
                commit(AGREEMENTS__MUTATIONS.GETTRADINGAGREEMENTS, []);

            }
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
